import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, InputGroup, Spinner, Alert } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { createFilm, getFornitori, getGeneriPersonalizzati, getCaseDiProduzione, getCategorie, getSupporti, getFilmById, searchTmdbFilms, importFilmFromTmdb, generateFilmWebDescription, searchLocalFilms, scrapeIbsUrl, scrapeDvdStore, getCompetitivePrice, generateEditorialBarcode, getTipiUscita, updateUbicazioniFilm, getImpostazioniPrezzi } from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import toast from 'react-hot-toast';
import { calcolaCostoAcquisto } from '../../utils/costoAcquisto';
import { applicaRiedizioneDaAnno, isRiedizioneDaAnno } from '../../utils/riedizione';

const NuovoFilm = () => {
  const initialFormData = {
    titolo: '',
    immagine_url: '',
    anno: '',
    durata: '',
    genere: '',
    regista: '',
    attori: '',
    trama: '',
    casa_di_produzione: '',
    casa_di_distribuzione: '',
    categoria: 'CINEMA',
    supporto: '',
    sku: '',
    barcode: '',
    barcode_ibs: '',
    prezzo_negozio: '',
    prezzo_negozio_base: '',
    prezzo_ibs: '',
    prezzo_dvdstore: '',
    condizione: 'Nuovo',
    quantita: 0,
    versione_noleggio: false,
    versione_editoriale: false,
    fuori_catalogo: false,
    iva: 22,
    fornitore_id: null,
    costo_acquisto: '',
    descrizione_web: '',
    ubicazione: '',
    da_pubblicare_su_ibs: true,
    note_ibs: '',
    prenotabile: false,
    data_uscita: '',
    riedizione: false,
    tipo_uscita: ''
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fornitori, setFornitori] = useState([]);
  const [generi, setGeneri] = useState([]);
  const [caseDiProduzione, setCaseDiProduzione] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [tipiUscita, setTipiUscita] = useState([]);
  const [tmdbResults, setTmdbResults] = useState([]);
  const [showTmdbResults, setShowTmdbResults] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isImporting, setIsImporting] = useState(false);
  const [isGeneratingWebDescription, setIsGeneratingWebDescription] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [localResults, setLocalResults] = useState([]);
  const [showLocalResults, setShowLocalResults] = useState(false);
  const [ibsUrl, setIbsUrl] = useState('');
  const [isScraping, setIsScraping] = useState(false);
  const [isCalcoloPrezzo, setIsCalcoloPrezzo] = useState(false);
  const [isGeneratingBarcode, setIsGeneratingBarcode] = useState(false);
  const [isDvdStoreScraping, setIsDvdStoreScraping] = useState(false);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [ubicazioniRows, setUbicazioniRows] = useState([{ ubicazione: '', quantita: 0 }]); // [{ ubicazione, quantita }]
  const [percentualeIbs, setPercentualeIbs] = useState(0);
  const [markupFissoIbs, setMarkupFissoIbs] = useState(0);
  // Finché è true il costo acquisto segue le regole SKU; si disattiva quando l'utente lo scrive a mano
  const [costoAuto, setCostoAuto] = useState(true);

  // Si attiva solo quando cambia l'anno, così una scelta manuale su Riedizione non viene riscritta
  useEffect(() => {
    if (!isRiedizioneDaAnno(formData.anno)) return;
    setFormData(prev => (prev.riedizione && prev.tipo_uscita ? prev : applicaRiedizioneDaAnno(prev)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.anno]);

  useEffect(() => {
    if (!costoAuto) return;
    const costo = calcolaCostoAcquisto(formData);
    if (costo !== null && parseFloat(formData.costo_acquisto) !== costo) {
      setFormData(prev => ({ ...prev, costo_acquisto: costo }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.sku, formData.supporto, formData.prezzo_negozio_base, formData.prezzo_negozio, costoAuto]);

  useEffect(() => {
    getImpostazioniPrezzi()
      .then(res => {
        setPercentualeIbs(res.data.ibs_markup_percentuale || 0);
        setMarkupFissoIbs(res.data.ibs_markup_fisso || 0);
      })
      .catch(() => {});
  }, []);

  const calcolaPrezzoIbs = (prezzoNegozio) => {
    if (!prezzoNegozio) return null;
    return arrotondaANovanta(prezzoNegozio * (1 + (parseFloat(percentualeIbs) || 0) / 100) + (parseFloat(markupFissoIbs) || 0));
  };

  // Stesso arrotondamento psicologico dell'equivalente backend (arrotonda_a_novanta).
  const arrotondaANovanta = (prezzo) => {
    if (!prezzo || prezzo <= 0) return prezzo;
    return Math.round((Math.floor(prezzo - 0.5) + 0.9) * 100) / 100;
  };

  const quantitaTotale = ubicazioniRows.reduce((sum, r) => sum + (parseInt(r.quantita) || 0), 0);

  const handleUbicazioneRowChange = (index, field, value) => {
    setUbicazioniRows(prev => prev.map((r, i) => i === index ? { ...r, [field]: field === 'quantita' ? (parseInt(value) || 0) : value } : r));
  };

  const handleAddUbicazioneRow = () => {
    setUbicazioniRows(prev => [...prev, { ubicazione: '', quantita: 0 }]);
  };

  const handleRemoveUbicazioneRow = (index) => {
    setUbicazioniRows(prev => prev.filter((_, i) => i !== index));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        setSelectedImage(file);
        setImagePreviewUrl(URL.createObjectURL(file));
    }
  };


  const location = useLocation();
  const navigate = useNavigate();

  const debouncedSearch = React.useRef(
    debounce(async (query) => {
        if (query.length > 2) {
            try {
                const response = await searchTmdbFilms(query);
                setTmdbResults(response.data);
                setShowTmdbResults(true);
            } catch (error) {
                console.error("Errore nella ricerca TMDB:", error);
            }
        } else {
            setShowTmdbResults(false);
        }
    }, 500)
  ).current;

  const debouncedSearchLocal = React.useRef(
    debounce(async (query) => {
        if (query.length > 2) {
            try {
                const response = await searchLocalFilms(query);
                setLocalResults(response.data);
                setShowLocalResults(true);
            } catch (error) {
                console.error("Errore nella ricerca locale:", error);
            }
        } else {
            setShowLocalResults(false);
        }
    }, 500)
  ).current;

  useEffect(() => {
    debouncedSearch(searchTerm);
  }, [searchTerm, debouncedSearch]);

  useEffect(() => {
    debouncedSearchLocal(localSearchTerm);
  }, [localSearchTerm, debouncedSearchLocal]);

  useEffect(() => {
    if (location.state && location.state.from === 'inventory' && location.state.barcode) {
      setFormData(prev => ({ ...prev, barcode: location.state.barcode }));
    }
  }, [location.state]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [fornitoriRes, generiRes, caseProdRes, catRes, tipiUscitaRes] = await Promise.all([
          getFornitori(),
          getGeneriPersonalizzati(),
          getCaseDiProduzione(),
          getCategorie(),
          getTipiUscita()
        ]);
        setFornitori(fornitoriRes.data.fornitori);

        // Precompila da variante se arrivo da creazione variante
        if (location.state && location.state.from === 'variant') {
          // Prendi tutti i dati passati, ma azzera i campi richiesti
          const variantData = { ...initialFormData, ...location.state };
          variantData.sku = '';
          variantData.prezzo_negozio = '';
          variantData.prezzo_negozio_base = '';
          variantData.prezzo_ibs = '';
          variantData.costo_acquisto = '';
          variantData.ubicazione = '';
          setFormData(variantData);
        } else {
          // Imposta ModenaCinema come fornitore predefinito solo se non duplicazione/importazione
          const queryParams = new URLSearchParams(location.search);
          const duplicateId = queryParams.get('duplicateId');
          const fromTmdb = location.state && location.state.from === 'tmdb';
          if (!duplicateId && !fromTmdb) {
            const modenaCinema = fornitoriRes.data.fornitori.find(f => f.denominazione && f.denominazione.toLowerCase().includes('modenacinema'));
            if (modenaCinema) {
              setFormData(prev => ({ ...prev, fornitore_id: modenaCinema.id }));
            }
          }
        }

        setGeneri(generiRes.data);
        setCaseDiProduzione(caseProdRes.data);
        setCategorie(catRes.data);
        setTipiUscita(tipiUscitaRes.data);
      } catch (error) {
        console.error("Errore nel caricamento dei dati per il form", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const duplicateId = queryParams.get('duplicateId');

    if (duplicateId) {
      const fetchFilmToDuplicate = async () => {
        try {
          const response = await getFilmById(parseInt(duplicateId));
          const duplicatedFilm = response.data;

          // Inizia con una base pulita e copia solo i campi pertinenti
          let newFilmData = { ...initialFormData };
          Object.keys(initialFormData).forEach(key => {
              if (duplicatedFilm.hasOwnProperty(key)) {
                  newFilmData[key] = duplicatedFilm[key];
              }
          });

          // Gestisci esplicitamente i campi da resettare o modificare
          newFilmData.titolo = duplicatedFilm.titolo || '';
          newFilmData.sku = '';
          newFilmData.barcode = '';
          // barcode_ibs ora viene duplicato normalmente

          // Copia durata se presente
          if (duplicatedFilm.durata) {
            newFilmData.durata = duplicatedFilm.durata;
          }

          setFormData(newFilmData);
          navigate(location.pathname, { replace: true });
        } catch (error) {
          console.error("Errore durante il recupero del film per la duplicazione:", error);
          alert("Errore durante il recupero dei dati per la duplicazione.");
        }
      };
      fetchFilmToDuplicate();
    }
  }, [location.search, navigate, location.pathname, initialFormData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = value;
    if (type === 'checkbox') {
        finalValue = checked;
    } else if (type === 'number') {
        const integerFields = ['anno', 'durata', 'quantita', 'iva'];
        if (integerFields.includes(name)) {
            finalValue = value === '' ? null : parseInt(value, 10);
        } else {
            finalValue = value === '' ? null : parseFloat(value);
        }
    }

    setFormData(prev => {
      const updated = { ...prev, [name]: finalValue };
      if (name === 'prezzo_negozio') {
        updated.prezzo_ibs = calcolaPrezzoIbs(prev.prezzo_negozio_base || finalValue);
      }
      return updated;
    });
  };

  // Logica SKU spostata nel backend
  const handleSkuChange = (e) => {
    const { value } = e.target;
    const upperCaseSku = value.toUpperCase();

    const SKU_CONDIZIONE_MAP = {
      'MC01_': 'Nuovo',
      'MCED01_': 'Nuovo',
      'MC02_': 'Usato - Ottime Condizioni',
      'MCED02_': 'Usato - Ottime Condizioni',
      'MC03_': 'Usato - Buone Condizioni',
    };
    let nuovaCondizione = formData.condizione;
    for (const [prefix, cond] of Object.entries(SKU_CONDIZIONE_MAP)) {
      if (upperCaseSku.startsWith(prefix)) {
        nuovaCondizione = cond;
        break;
      }
    }
    
    setCostoAuto(true);
    setFormData(prev => ({
      ...prev,
      sku: upperCaseSku,
      condizione: nuovaCondizione,
      versione_noleggio: upperCaseSku.startsWith('MC03_'), // Imposta automaticamente
    }));
  };

  const handleCostoChange = (e) => {
    setCostoAuto(e.target.value === '');
    handleChange(e);
  };

  const handleTypeaheadChange = (name, value) => {
    const singleValue = Array.isArray(value) ? value[0] : value;
    setFormData({ ...formData, [name]: singleValue || '' });
  };

  const handleCalcolaPrezzo = async () => {
    const ean = formData.barcode_ibs;
    const condizione = formData.condizione;
    if (!ean) {
      toast.error('Inserisci prima il Barcode IBS (EAN)');
      return;
    }
    setIsCalcoloPrezzo(true);
    try {
      const res = await getCompetitivePrice(ean, condizione, formData?.costo_acquisto ? parseFloat(formData.costo_acquisto) : null);
      const { competitive_price, found } = res.data;
      if (found && competitive_price !== null) {
        setFormData(prev => ({ ...prev, prezzo_ibs: competitive_price }));
        toast.success(`Prezzo IBS €${competitive_price.toFixed(2)}: batte ${res.data.concorrente} (${res.data.mercato_totale?.toFixed(2)}€ consegnato)${res.data.battibile === false ? ' — impostato il minimo per il margine' : ''}`);
      } else {
        toast('Nessun prezzo competitor trovato per questo EAN/condizione', { icon: '⚠️' });
      }
    } catch (err) {
      toast.error('Errore nel calcolo del prezzo: ' + (err?.response?.data?.detail || err.message));
    } finally {
      setIsCalcoloPrezzo(false);
    }
  };



  const handleBarcodeBlur = (e) => {
    const barcode = e.target.value;
    setFormData({ ...formData, barcode: barcode });
  };

  const DVD_STORE_FIELDS = ['titolo', 'genere', 'attori', 'regista', 'anno', 'durata', 'trama', 'casa_di_produzione', 'casa_di_distribuzione', 'supporto', 'prezzo_dvdstore', 'tipo_uscita', 'riedizione', 'immagine_url'];

  const handleBarcodeIbsBlur = async (e) => {
    const ean = e.target.value.trim();
    if (ean) {
      // Di default il barcode IBS diventa barcode e SKU MC01_<barcode>, senza toccare valori già presenti
      setFormData(prev => ({
        ...prev,
        barcode: prev.barcode || ean,
        sku: prev.sku || `MC01_${ean}`,
        condizione: !prev.sku && !prev.condizione ? 'Nuovo' : prev.condizione,
      }));
      if (!formData.sku) setCostoAuto(true);
    }
    if (!/^\d{8,13}$/.test(ean)) return;
    setIsDvdStoreScraping(true);
    try {
      const res = await scrapeDvdStore(ean);
      const d = res.data;
      setFormData(prev => {
        const updated = { ...prev };
        DVD_STORE_FIELDS.forEach(f => { if (d[f] != null && !prev[f]) updated[f] = d[f]; });
        if (d.fuori_catalogo_dvdstore) updated.fuori_catalogo = true;
        return updated;
      });
      toast.success(`DVD Store: trovato "${d.titolo || ean}"${d.fuori_catalogo_dvdstore ? ' — Fuori catalogo' : ''}`);
    } catch (err) {
      if (err?.response?.status !== 404) toast.error('Errore scraping DVD Store');
    } finally {
      setIsDvdStoreScraping(false);
    }
  };

  const handleImportDvdStore = async () => {
    const ean = formData.barcode_ibs?.trim();
    if (!ean || !/^\d{8,13}$/.test(ean)) {
      toast.error('Inserisci prima un Barcode IBS valido (8-13 cifre)');
      return;
    }
    setIsDvdStoreScraping(true);
    try {
      const res = await scrapeDvdStore(ean);
      const d = res.data;
      setFormData(prev => {
        const updated = { ...prev };
        DVD_STORE_FIELDS.forEach(f => { if (d[f] != null) updated[f] = d[f]; });
        if (d.fuori_catalogo_dvdstore) updated.fuori_catalogo = true;
        return updated;
      });
      toast.success(`DVD Store: importato "${d.titolo || ean}"${d.fuori_catalogo_dvdstore ? ' — Fuori catalogo' : ''}`);
    } catch (err) {
      if (err?.response?.status === 404) toast('Film non trovato su DVD Store', { icon: '⚠️' });
      else toast.error('Errore scraping DVD Store');
    } finally {
      setIsDvdStoreScraping(false);
    }
  };

  const handleListBlur = (e) => {
    const { name, value } = e.target;
    const formattedValue = value.replace(/,\s*/g, '; ');
    setFormData(prev => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const formDataToSend = new FormData();

      // Guardia: SKU MC01/02/03 → versione_editoriale non può essere true
      const safedData = { ...formData };
      const sku = (safedData.sku || '').toUpperCase();
      if (sku.startsWith('MC01') || sku.startsWith('MC02') || sku.startsWith('MC03')) {
        safedData.versione_editoriale = false;
      }
      // Quantità e ubicazione sono derivate dalle righe ubicazioni_stock, salvate a parte
      delete safedData.quantita;
      delete safedData.ubicazione;

      formDataToSend.append('film_data', JSON.stringify(safedData));

      // Append the file if selected
      if (selectedImage) {
        formDataToSend.append('immagine_file', selectedImage);
      }

      const response = await createFilm(formDataToSend);

      const righeValide = ubicazioniRows
        .map(r => ({ ubicazione: (r.ubicazione || '').trim(), quantita: parseInt(r.quantita) || 0 }))
        .filter(r => r.ubicazione && r.quantita > 0);
      if (righeValide.length > 0) {
        await updateUbicazioniFilm(response.data.film.id, righeValide);
      }

      alert(`Film creato con successo! ${response.data.image_message}`);
      // Se la creazione arriva dall'inventario, torna all'inventario passando il nuovo prodotto
      if (location.state && location.state.from === 'inventory') {
        navigate('/magazzino/inventario', { state: { newProduct: response.data, wasScanning: location.state.wasScanning } });
      } else {
        navigate('/film');
      }
    } catch (error) {
      console.error('Errore nella creazione del film:', error.response || error);
      let errorMessage = 'Si è verificato un errore sconosciuto durante la creazione del film.';
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        if (Array.isArray(detail) && detail.every(e => typeof e === 'object' && e.msg)) {
          // Errore validazione FastAPI: array di oggetti
          errorMessage = detail.map(e => `${e.loc ? e.loc.join('.') + ': ' : ''}${e.msg}`).join('\n');
        } else if (typeof detail === 'string') {
          errorMessage = detail;
        } else {
          errorMessage = JSON.stringify(detail);
        }
      }
      setError(errorMessage);
    }
  };

  const handleImportTMDB = async (tmdbId) => {
    setIsImporting(true);
    try {
        const response = await importFilmFromTmdb(tmdbId); // Ora restituisce FilmCreateUpdateResponse
        const importedFilm = response.data.film; // Prendi l'oggetto film dalla risposta
        const imageMessage = response.data.image_message; // Prendi il messaggio dell'immagine

        setFormData(prev => ({
            ...prev,
            titolo: importedFilm.titolo ?? prev.titolo,
            anno: importedFilm.anno ?? prev.anno,
            genere: importedFilm.genere ?? prev.genere,
            regista: importedFilm.regista ?? prev.regista,
            attori: importedFilm.attori ?? prev.attori,
            trama: importedFilm.trama ?? prev.trama,
            casa_di_produzione: importedFilm.casa_di_produzione ?? prev.casa_di_produzione,
            tmdb_id: importedFilm.tmdb_id ?? prev.tmdb_id,
            durata: importedFilm.durata ?? prev.durata,
            immagine_url: importedFilm.immagine_url ?? prev.immagine_url, // Aggiorna anche l'immagine_url
        }));
        alert(`Dati importati da TMDB con successo! ${imageMessage}`); // Usa il messaggio dell'immagine
        setShowTmdbResults(false);
    } catch (error) {
        console.error("Errore importazione TMDB:", error);
        alert(error.response?.data?.detail || "Errore durante l'importazione da TMDB.");
    } finally {
        setIsImporting(false);
    }
  };

  const handleScrapeIBS = async () => {
    if (!ibsUrl) {
        alert("Per favore, inserisci un URL di IBS.it.");
        return;
    }
    setIsScraping(true);
    try {
        const response = await scrapeIbsUrl(ibsUrl);
        const scrapedData = response.data;
        
        // In modalità "Nuovo Film", vogliamo che tutti i campi siano popolati,
        // quindi non sovrascriviamo né eliminiamo campi specifici da scrapedData.
        
        setFormData(prev => {
            const updatedData = { ...prev };
            for (const key in scrapedData) {
                if (scrapedData[key] !== null && scrapedData[key] !== undefined) {
                    updatedData[key] = scrapedData[key];
                }
            }
            return updatedData;
        });

        alert("Dati importati da IBS con successo!");
    } catch (error) {
        console.error("Errore scraping IBS:", error);
        alert(error.response?.data?.detail || "Errore durante l'importazione da IBS.it.");
    } finally {
        setIsScraping(false);
    }
  };

  const handleUseAsTemplate = async (filmId) => {
    try {
      const response = await getFilmById(filmId);
      const templateFilm = response.data;

      const newFilmData = {
        ...initialFormData,
        ...templateFilm,
        id: undefined,
        titolo: `${templateFilm.titolo} (Copia)`,
        sku: '',
        barcode: '',
        // barcode_ibs and durata are now preserved from templateFilm
        ubicazione: '',
        costo_acquisto: '',
        descrizione_web: '',
        quantita: 0,
      };

      setFormData(newFilmData);
      setUbicazioniRows([{ ubicazione: '', quantita: 0 }]);
      setShowLocalResults(false);
      setLocalSearchTerm('');
      alert('Modulo compilato con i dati del film selezionato. Modifica i campi necessari e salva.');
    } catch (error) {
      console.error("Errore durante il recupero del film per il template:", error);
      alert("Errore durante il recupero dei dati del film.");
    }
  };

  const handleGenerateWebDescription = async () => {
    setIsGeneratingWebDescription(true);
    try {
      let currentFilmId = formData.id;

      // If the film hasn't been created yet, create it first
      if (!currentFilmId) {
        const dataToSubmit = {
            ...formData,
            anno: formData.anno ? parseInt(formData.anno) : null,
            prezzo_negozio: formData.prezzo_negozio ? parseFloat(formData.prezzo_negozio) : null,
            prezzo_negozio_base: formData.prezzo_negozio_base ? parseFloat(formData.prezzo_negozio_base) : null,
            prezzo_ibs: formData.prezzo_ibs ? parseFloat(formData.prezzo_ibs) : null,
            costo_acquisto: formData.costo_acquisto ? parseFloat(formData.costo_acquisto) : null,
            fornitore_id: formData.fornitore_id ? parseInt(formData.fornitore_id) : null,
        };
        const createdFilm = await createFilm(dataToSubmit);
        currentFilmId = createdFilm.data.id;
        setFormData(prev => ({ ...prev, id: currentFilmId })); // Update form data with new ID
        alert('Film salvato automaticamente per generare la descrizione web.');
      }

      const response = await generateFilmWebDescription(currentFilmId);
      setFormData(prev => ({ ...prev, descrizione_web: response.data.descrizione_web }));
      alert('Descrizione web generata con successo!');
    } catch (error) {
      console.error('Errore durante la generazione della descrizione web:', error.response || error);
      alert(error.response?.data?.detail || 'Errore durante la generazione della descrizione web.');
    } finally {
      setIsGeneratingWebDescription(false);
    }
  };

  return (
    <Container>
        <div className="sticky-action-bar">
            <Row>
                <Col>
                    <h2>Nuovo Film</h2>
                </Col>
                <Col className="text-end">
                    <Button variant="info" onClick={handleGenerateWebDescription} disabled={isGeneratingWebDescription} className="me-2">
                        {isGeneratingWebDescription ? 'Generazione...' : 'Genera Descrizione Web'}
                    </Button>
                    <Button variant="secondary" onClick={() => navigate('/film')} className="me-2">
                        Torna alla Lista
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Salva Film
                    </Button>
                </Col>
            </Row>
        </div>

      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          {Array.isArray(error)
            ? <ul>{error.map((e, i) => <li key={i}>{e}</li>)}</ul>
            : error.split('\n').map((line, i) => <div key={i}>{line}</div>)}
        </Alert>
      )}

      <Form onSubmit={(e) => e.preventDefault()}>
        {/* Card: CODICI */}
        <Card className="mb-4">
          <Card.Header>CODICI</Card.Header>
          <Card.Body>
            <Row>
              <Col><Form.Group className="mb-3" controlId="formSku"><Form.Label>SKU</Form.Label><Form.Control type="text" name="sku" value={formData.sku} onChange={handleSkuChange} /></Form.Group></Col>
              <Col><Form.Group className="mb-3" controlId="formBarcode"><Form.Label>Barcode</Form.Label><Form.Control type="text" name="barcode" value={formData.barcode} onChange={handleChange} onBlur={handleBarcodeBlur} /></Form.Group></Col>
              <Col><Form.Group className="mb-3" controlId="formBarcodeIbs"><Form.Label>Barcode IBS {isDvdStoreScraping && <Spinner as="span" animation="border" size="sm" className="ms-1" />}</Form.Label><InputGroup><Form.Control type="text" name="barcode_ibs" value={formData.barcode_ibs} onChange={handleChange} onBlur={handleBarcodeIbsBlur} /><Button variant="outline-info" onClick={handleImportDvdStore} disabled={isDvdStoreScraping} title="Importa/aggiorna tutti i campi da DVD Store">{isDvdStoreScraping ? <Spinner as="span" animation="border" size="sm" /> : 'DVD Store'}</Button></InputGroup></Form.Group></Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Card: Importa Dati */}
        <Card className="mb-3">
            <Card.Header>Importa Dati</Card.Header>
            <Card.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Importa da URL IBS</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Incolla l'URL del prodotto da IBS.it"
                            value={ibsUrl}
                            onChange={(e) => setIbsUrl(e.target.value)}
                        />
                        <Button
                            variant="success"
                            onClick={handleScrapeIBS}
                            disabled={isScraping}
                        >
                            {isScraping ? <Spinner as="span" animation="border" size="sm" /> : 'Importa da IBS'}
                        </Button>
                    </InputGroup>
                </Form.Group>
                <hr />
                <Form.Group className="mb-3">
                    <Form.Label>Cerca su TMDB</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Cerca film per titolo..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                    {showTmdbResults && (
                        <div className="list-group" style={{ zIndex: 1000, position: 'absolute' }}>
                            {tmdbResults.map(movie => (
                                <div key={movie.tmdb_id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                                    {movie.titolo} ({movie.anno}){movie.regista ? ` - ${movie.regista}` : ''}
                                    <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => handleImportTMDB(movie.tmdb_id)}
                                        disabled={isImporting}
                                    >
                                        Importa da TMDB
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
                </Form.Group>
            </Card.Body>
        </Card>

        {/* Card: Ricerca in Archivio Locale */}
        <Card className="mb-3">
            <Card.Header>Ricerca in Archivio Locale</Card.Header>
            <Card.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Cerca per Titolo, SKU o Barcode</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Cerca film nel tuo database..."
                            value={localSearchTerm}
                            onChange={(e) => setLocalSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                    {showLocalResults && (
                        <div className="list-group" style={{ zIndex: 999, position: 'absolute' }}>
                            {localResults.map(film => (
                                <div key={film.id} className="list-group-item list-group-item-action">
                                    <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1">{film.titolo}</h5>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            onClick={() => handleUseAsTemplate(film.id)}
                                        >
                                            Usa come Template
                                        </Button>
                                    </div>
                                    <p className="mb-1">
                                        <strong>SKU:</strong> {film.sku || 'N/A'} | 
                                        <strong> Barcode:</strong> {film.barcode || 'N/A'} | 
                                        <strong> Barcode IBS:</strong> {film.barcode_ibs || 'N/A'} |
                                        <strong> Supporto:</strong> {film.supporto || 'N/A'}
                                    </p>
                                    <small>Quantità: {film.quantita}</small>
                                </div>
                            ))}
                        </div>
                    )}
                </Form.Group>
            </Card.Body>
        </Card>
        
        {/* Card: SCHEDA FILM */}
        <Card className="mb-4">
          <Card.Header>SCHEDA FILM</Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formTitolo">
                  <Form.Label>Titolo</Form.Label>
                  <Form.Control type="text" name="titolo" value={formData.titolo} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3" controlId="formAnno">
                  <Form.Label>Anno</Form.Label>
                  <Form.Control type="number" name="anno" value={formData.anno} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3" controlId="formDurata">
                  <Form.Label>Durata (min)</Form.Label>
                  <Form.Control type="number" name="durata" value={formData.durata} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formImmagineUrl">
                        <Form.Label>URL Immagine Esterno</Form.Label>
                        <Form.Control type="text" name="immagine_url" value={formData.immagine_url} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formImmagineFile">
                        <Form.Label>Oppure Carica Immagine Locale</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </Form.Group>
                </Col>
            </Row>

            {(imagePreviewUrl || formData.immagine_url) && (
              <div className="mb-3 text-center">
                <img 
                  src={imagePreviewUrl || (formData.immagine_url.startsWith('http') ? formData.immagine_url : process.env.REACT_APP_API_BASE_URL + formData.immagine_url)} 
                  alt="Anteprima" 
                  style={{ maxWidth: '200px', maxHeight: '200px', border: '1px solid #dee2e6' }}
                />
              </div>
            )}

            <Row>
              <Col md={6}><Form.Group className="mb-3" controlId="formRegista"><Form.Label>Regista</Form.Label><Form.Control type="text" name="regista" value={formData.regista} onChange={handleChange} onBlur={handleListBlur} /></Form.Group></Col>
              <Col md={6}><Form.Group className="mb-3" controlId="formGenere"><Form.Label>Genere</Form.Label><Typeahead id="genere-typeahead" options={generi} allowNew onChange={(s) => handleTypeaheadChange('genere', s)} onInputChange={(t) => handleTypeaheadChange('genere', t)} selected={formData.genere ? [formData.genere] : []} /></Form.Group></Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formCasaProduzione">
                  <Form.Label>Casa di Produzione</Form.Label>
                  <Typeahead id="casa-produzione-typeahead" options={caseDiProduzione} allowNew onChange={(s) => handleTypeaheadChange('casa_di_produzione', s)} onInputChange={(t) => handleTypeaheadChange('casa_di_produzione', t)} selected={formData.casa_di_produzione ? [formData.casa_di_produzione] : []} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formCasaDistribuzione">
                  <Form.Label>Casa di Distribuzione</Form.Label>
                  <Form.Control type="text" name="casa_di_distribuzione" value={formData.casa_di_distribuzione || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3" controlId="formAttori"><Form.Label>Attori</Form.Label><Form.Control as="textarea" rows={2} name="attori" value={formData.attori} onChange={handleChange} onBlur={handleListBlur} /></Form.Group>
            <Form.Group className="mb-3" controlId="formTrama"><Form.Label>Trama</Form.Label><Form.Control as="textarea" rows={4} name="trama" value={formData.trama} onChange={handleChange} /></Form.Group>
            <Form.Group className="mb-3" controlId="formNoteIbs">
              <Form.Label>Note IBS <span className="text-muted fw-normal small">(differenze rispetto alla versione IBS — appare in descrizione Mirakl)</span></Form.Label>
              <Form.Control as="textarea" rows={2} name="note_ibs" value={formData.note_ibs || ''} onChange={handleChange} placeholder="Es. Manca il libretto originale, copertina leggermente rovinata..." />
            </Form.Group>
          </Card.Body>
        </Card>

        {/* Card: DETTAGLI PRODOTTO (SENZA SKU, BARCODE, BARCODE IBS) */}
        <Card className="mb-4">
          <Card.Header>DETTAGLI PRODOTTO</Card.Header>
          <Card.Body>
            <Row>
              <Col><Form.Group className="mb-3" controlId="formCategoria"><Form.Label>Categoria</Form.Label><Typeahead id="categoria-typeahead" options={categorie} allowNew onChange={(s) => handleTypeaheadChange('categoria', s)} onInputChange={(t) => handleTypeaheadChange('categoria', t)} selected={formData.categoria ? [formData.categoria] : []} /></Form.Group></Col>
              <Col>
                <Form.Group className="mb-3" controlId="formSupporto">
                  <Form.Label>Supporto</Form.Label>
                  <Form.Select name="supporto" value={formData.supporto} onChange={handleChange}>
                    <option value="">Seleziona supporto...</option>
                    <option value="4K">4K</option>
                    <option value="DVD">DVD</option>
                    <option value="BLU RAY">BLU RAY</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formCondizione">
                  <Form.Label>Condizione</Form.Label>
                  <Form.Select name="condizione" value={formData.condizione || ''} onChange={handleChange}>
                    <option value="">Seleziona condizione...</option>
                    <option value="Nuovo">Nuovo</option>
                    <option value="Usato - Ottime Condizioni">Usato - Ottime Condizioni</option>
                    <option value="Usato - Buone Condizioni">Usato - Buone Condizioni</option>
                    <option value="Usato - Discrete Condizioni">Usato - Discrete Condizioni</option>
                    <option value="Usato - Accettabile">Usato - Accettabile</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Ubicazioni <span className="text-muted fw-normal small">(una riga per ogni locazione fisica)</span></Form.Label>
              {ubicazioniRows.map((riga, index) => (
                  <InputGroup className="mb-2" key={index}>
                      <Form.Control
                          type="text"
                          value={riga.ubicazione}
                          onChange={(e) => handleUbicazioneRowChange(index, 'ubicazione', e.target.value)}
                          list="ubicazioni-list"
                          placeholder="Ubicazione"
                      />
                      <Form.Control
                          type="number"
                          min="0"
                          value={riga.quantita}
                          onChange={(e) => handleUbicazioneRowChange(index, 'quantita', e.target.value)}
                          style={{ maxWidth: 100 }}
                          placeholder="Qtà"
                      />
                      <Button variant="outline-danger" onClick={() => handleRemoveUbicazioneRow(index)}>&times;</Button>
                  </InputGroup>
              ))}
              <datalist id="ubicazioni-list">
                  <option value="BR NUOVI LIB" />
                  <option value="BR USATI LIB" />
                  <option value="DVD NUOVI LIB" />
                  <option value="DVD USATI LIB" />
                  <option value="CEX" />
                  <option value="EXN" />
              </datalist>
              <Button variant="outline-secondary" size="sm" onClick={handleAddUbicazioneRow}>+ Aggiungi ubicazione</Button>
            </Form.Group>
          </Card.Body>
        </Card>

        {/* Card: PREZZI E MAGAZZINO (NUOVA POSIZIONE) */}
        <Card className="mb-4">
          <Card.Header>PREZZI E MAGAZZINO</Card.Header>
          <Card.Body>
            <Row>
              <Col md={4}><Form.Group className="mb-3" controlId="formPrezzoNegozio"><Form.Label>Prezzo Negozio</Form.Label><InputGroup><Form.Control type="number" step="0.01" name="prezzo_negozio" value={formData.prezzo_negozio} onChange={handleChange} /></InputGroup></Form.Group></Col>
              <Col md={4}><Form.Group className="mb-3" controlId="formPrezzoIbs"><Form.Label>Prezzo IBS <span className="text-muted small">(dal prezzo base: +{percentualeIbs}% +{markupFissoIbs}€)</span></Form.Label><InputGroup><Form.Control type="number" step="0.01" name="prezzo_ibs" value={formData.prezzo_ibs || ''} disabled readOnly /><Button variant="outline-secondary" onClick={handleCalcolaPrezzo} disabled={isCalcoloPrezzo || !formData.barcode_ibs} title="Sovrascrivi con il prezzo competitivo da IBS Marketplace (P11)">{isCalcoloPrezzo ? <Spinner as="span" animation="border" size="sm" /> : '💰 P11'}</Button></InputGroup></Form.Group></Col>
              <Col md={4}><Form.Group className="mb-3" controlId="formCostoAcquisto"><Form.Label>Costo Acquisto</Form.Label><Form.Control type="number" step="0.01" name="costo_acquisto" value={formData.costo_acquisto} onChange={handleCostoChange} /></Form.Group></Col>
              <Col md={4}><Form.Group className="mb-3" controlId="formPrezzoDvdStore"><Form.Label>Prezzo DVD Store</Form.Label><Form.Control type="number" step="0.01" name="prezzo_dvdstore" value={formData.prezzo_dvdstore} onChange={handleChange} placeholder="auto da barcode IBS" /></Form.Group></Col>
              <Col md={4}><Form.Group className="mb-3" controlId="formIva"><Form.Label>IVA %</Form.Label><Form.Control type="number" step="0.1" name="iva" value={formData.iva} onChange={handleChange} /></Form.Group></Col>
            </Row>
            <Row>
              <Col md={4}><Form.Group className="mb-3" controlId="formQuantita"><Form.Label>Quantità <span className="text-muted fw-normal small">(somma delle ubicazioni sopra)</span></Form.Label><Form.Control type="number" value={quantitaTotale} readOnly disabled /></Form.Group></Col>
            </Row>
            <Form.Group className="mb-3" controlId="formFornitore">
              <Form.Label>Fornitore</Form.Label>
              <Form.Select name="fornitore_id" value={formData.fornitore_id || ''} onChange={handleChange}>
                  <option value="">Nessun fornitore</option>
                  {fornitori.map(f => (
                      <option key={f.id} value={f.id}>{f.denominazione}</option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Card.Body>
        </Card>

        {/* Card: CATALOGO (NUOVA POSIZIONE) */}
        <Card className="mb-4">
          <Card.Header>CATALOGO</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3">
              <Form.Check type="switch" id="versione-noleggio" label="Versione Noleggio" name="versione_noleggio" checked={formData.versione_noleggio} onChange={handleChange} className="d-inline-block me-3" />
              <Form.Check type="switch" id="versione-editoriale" label="Versione Editoriale" name="versione_editoriale" checked={formData.versione_editoriale || false} onChange={handleChange} className="d-inline-block me-3" />
              <Form.Check type="switch" id="fuori-catalogo" label="Fuori Catalogo" name="fuori_catalogo" checked={formData.fuori_catalogo} onChange={handleChange} className="d-inline-block me-3" />
              <Form.Check type="switch" id="da-pubblicare-su-ibs" label="Presente su IBS" name="da_pubblicare_su_ibs" checked={formData.da_pubblicare_su_ibs} onChange={handleChange} className="d-inline-block me-3" />
              <Form.Check type="switch" id="prenotabile" label="Prenotabile (Novità)" name="prenotabile" checked={formData.prenotabile || false} onChange={handleChange} className="d-inline-block me-3" />
              <Form.Check type="switch" id="riedizione" label="Riedizione / Ed. Speciale" name="riedizione" checked={formData.riedizione || false} onChange={handleChange} className="d-inline-block" />
            </Form.Group>
            {formData.prenotabile && (
              <Form.Group className="mb-3">
                <Form.Label>Data di uscita prevista</Form.Label>
                <Form.Control
                  type="date"
                  name="data_uscita"
                  value={formData.data_uscita || ''}
                  onChange={handleChange}
                  style={{ maxWidth: 200 }}
                />
                <Form.Text className="text-muted">Se la data è futura il film apparirà nelle "Prossime uscite" dell'ecommerce.</Form.Text>
              </Form.Group>
            )}
            {formData.riedizione && (
              <Form.Group className="mb-3">
                <Form.Label>Tipo uscita / Edizione</Form.Label>
                <Form.Control
                  type="text"
                  name="tipo_uscita"
                  value={formData.tipo_uscita || ''}
                  onChange={handleChange}
                  placeholder="Es. Edizione 4K, Director's Cut, Edizione anniversario 40°..."
                  style={{ maxWidth: 400 }}
                  list="tipi-uscita-list"
                />
                <datalist id="tipi-uscita-list">
                  {tipiUscita.map(t => <option key={t} value={t} />)}
                </datalist>
                <Form.Text className="text-muted">Descrizione breve del tipo di riedizione, visibile nelle Novità dell'ecommerce.</Form.Text>
              </Form.Group>
            )}
            {formData.versione_editoriale && (
              <div className="mb-3 p-3 border rounded bg-light">
                <p className="mb-2 text-muted small fw-bold">📦 VERSIONE EDITORIALE — Barcode fittizio</p>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={async () => {
                    setIsGeneratingBarcode(true);
                    try {
                      const res = await generateEditorialBarcode();
                      const { barcode, sku_nuovo, sku_usato } = res.data;
                      const condizione = formData.condizione || 'Nuovo';
                      const isNuovo = condizione === 'Nuovo';
                      const suggestedSku = isNuovo ? sku_nuovo : sku_usato;
                      const nuovaCondizione = isNuovo ? 'Nuovo' : 'Usato - Ottime Condizioni';
                      setFormData(prev => ({ ...prev, barcode, sku: suggestedSku, condizione: nuovaCondizione }));
                      toast.success(`Barcode editoriale generato: ${barcode}`);
                    } catch (err) {
                      toast.error('Errore nella generazione del barcode editoriale');
                    } finally {
                      setIsGeneratingBarcode(false);
                    }
                  }}
                  disabled={isGeneratingBarcode}
                >
                  {isGeneratingBarcode ? 'Generazione...' : '⚙️ Genera Barcode Editoriale'}
                </Button>
                {formData.barcode && formData.barcode.startsWith('ED') && (
                  <span className="ms-3 font-monospace text-success">{formData.barcode}</span>
                )}
                <p className="mt-2 mb-0 text-muted small">
                  Il barcode (e lo SKU) vengono generati automaticamente al salvataggio se non già presenti.
                </p>
              </div>
            )}
          </Card.Body>
        </Card>



      </Form>
    </Container>
  );
};

export default NuovoFilm;
